import { render } from "./BuySpecificLotteryNumber.vue?vue&type=template&id=557bedc6"
import script from "./BuySpecificLotteryNumber.vue?vue&type=script&lang=js"
export * from "./BuySpecificLotteryNumber.vue?vue&type=script&lang=js"

import "./BuySpecificLotteryNumber.vue?vue&type=style&index=0&id=557bedc6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__